

import { React, useEffect } from "react";
import { ArrowLeftOutlined } from '@ant-design/icons';
import logo from '../media/Brahma Jyoti Green Energy.png'
import solarfield from "../media/Photos/solar-field.jpg";
import solarman from "../media/Photos/Solar Man.jpg";
import solarpanel from "../media/Photos/solar-panels.jpg";
import hydro from "../media/Photos/hydro.jpg";
import { useNavigate } from "react-router-dom";


const BrahmaJyotiGreenEnergy = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  }
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className="about-container">
      <div className="content-left">
      <p style={{ display: 'flex' }}>
          <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
        </p>
        <h1 className="title">BRAHMA JYOTI GREEN ENERGY LTD</h1>
        

        <div style={{ textAlign: 'center' }}>
          <img src={logo} alt={logo} width={300} />
        </div>
        <div className="section company-details">
          <h2>Company Details</h2>
          <p><strong>Company Name:</strong> Brahma Jyoti Green Energy Limited</p>
          <p><strong>Industry:</strong> Renewable Energy</p>
          <p><strong>Headquarters:</strong> Kathmandu, Nepal</p>
        </div>

        <div className="section about-us">
          <h2>About Us</h2>
          <p>Brahma Jyoti Green Energy Limited is a leading force in Nepal’s renewable energy sector, dedicated to advancing sustainable power solutions through its specialized focus on commercial solar power and hydropower projects. Our company is committed to leveraging Nepal’s natural resources to deliver innovative and efficient energy solutions that meet the growing demand for clean energy.</p>
        </div>

        <div className="section operations">
          <h2>Core Areas of Operation</h2>

          <ul>
            <li><strong>Commercial Solar Power Plants:</strong>
              <p>Brahma Jyoti Green Energy Limited excels in the development, implementation, and management of large-scale commercial solar power projects. Our solar installations are designed to provide high-efficiency energy solutions to businesses, industries, and institutions. By employing cutting-edge photovoltaic technology and incorporating best practices in energy management, we ensure that our solar plants offer reliable, cost-effective, and sustainable energy.</p>

            </li>
            <div style={{ textAlign: 'center' }} >
              <img src={solarfield} alt="solarfield" width={200}></img>
              <img src={solarpanel} alt="solarpanel" width={200}></img>
              <img src={solarman} alt="solarman" width={200}></img>
            </div>

            <li><strong>Hydropower Projects:</strong>
              <p>Harnessing Nepal’s abundant river systems, Brahma Jyoti Green Energy Limited is also a prominent player in the hydropower sector. Our hydropower projects are carefully planned and executed to generate clean and renewable energy while minimizing environmental impact. From initial feasibility studies to the construction and operational phases, we focus on delivering hydropower solutions that are both technically and economically viable.</p>
            </li>
            <div style={{ textAlign: 'center' }} >
              <img src={hydro} alt="hydro" width={200}></img>

            </div>
          </ul>
        </div>

        <div className="section objectives">
          <h2>Key Objectives</h2>
          <ul>
            <li><strong>Sustainability:</strong> We are committed to promoting environmental sustainability through the development of clean energy sources. Our projects are designed to reduce carbon emissions, conserve natural resources, and support Nepal’s climate action goals.</li>
            <li><strong>Innovation:</strong> By integrating the latest technological advancements and best practices, we aim to enhance the efficiency and effectiveness of our solar and hydropower projects.</li>
            <li><strong>Economic Growth:</strong> Brahma Jyoti Green Energy Limited is dedicated to contributing to Nepal’s economic development by creating job opportunities, stimulating local economies, and reducing the country’s dependency on imported energy.</li>
            <li><strong>Community Engagement:</strong> We strive to positively impact the communities in which we operate by engaging with local stakeholders, supporting community development initiatives, and ensuring that our projects benefit the broader society.</li>
          </ul>
        </div>

        <div className="section impact">
          <h2>Impact and Benefits</h2>
          <ul>
            <li><strong>Environmental Impact:</strong> Our solar and hydropower projects play a crucial role in reducing greenhouse gas emissions and promoting environmental conservation. Solar power offers a zero-emission energy source, while our hydropower projects are designed to balance energy production with ecological preservation.</li>
            <li><strong>Energy Security:</strong> By focusing on renewable energy sources, we enhance Nepal’s energy security and stability, reducing vulnerability to energy supply disruptions and price volatility.</li>
            <li><strong>Economic Value:</strong> Our investments in renewable energy infrastructure drive economic growth by creating jobs, supporting local businesses, and generating a sustainable revenue stream for the country.</li>
          </ul>
        </div>

        <div className="section conclusion">
          <h2>Conclusion</h2>
          <p>Brahma Jyoti Green Energy Limited is dedicated to advancing Nepal’s renewable energy landscape through our expertise in commercial solar and hydropower projects. Our commitment to sustainability, innovation, and economic development positions us as a key player in shaping Nepal’s energy future. Through our projects, we aim to contribute to a greener, more sustainable, and economically vibrant Nepal.</p>
        </div>
      </div>

    </div>
  )
}

export default BrahmaJyotiGreenEnergy;